import { AddressDetail } from '@ravago/shared/page-data/models/elements/address.model';
import { Customer, CustomerListItem } from '@ravago/shared/page-data/models/features';

export class CustomerUtils {
  static async getCurrentCustomer(): Promise<Customer | undefined> {
    const response = await fetch(`/api/customer/current-customer`);
    if (response.ok) {
      return response.json();
    }
    return undefined;
  }

  static async getAddressDetails(addressId: number): Promise<AddressDetail | undefined> {
    const response = await fetch(`/api/customer/addresses/${addressId}`);
    if (response.ok) {
      return response.json();
    }
    return undefined;
  }

  static async getAllCustomers(search?: string, perPage?: string): Promise<Array<CustomerListItem> | undefined> {
    const response = await fetch(`/api/customers?size=${perPage || '5000'}&customerSearchParameter=${search || ''}`);

    if (response.ok) {
      return response.json();
    }
    return undefined;
  }
}
